module.exports = __webpack_public_path__ + "static/media/fk.69e54cb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/fk.png
// module id = 1846
// module chunks = 0